import React from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from '@brighterion/br-ui';
import { GLOBAL_RULE_TABLE_ORDER } from 'Common/enums';
import { EventNames, EventTypes, trackEvent } from '@brighterion/insights';
import styles from './TableDropDown.css';

interface Props {
    selectViewOption: string;
    setSelectViewOption: Function;
}
export const TableDropDown = ({ selectViewOption, setSelectViewOption }: Props) => {
    const { t } = useTranslation();
    return (
        <div>
            <Select
                dataTestId='Table-view-option'
                className={styles.GlobalRuleDropdownView}
                handleClickCallback={(value) => {
                    trackEvent({
                        eventType: EventTypes.track,
                        eventName: EventNames.click,
                        payload: {
                            clickIdentifier: 'Global Rules - Change View',
                            text: `Change View: ${value[0]}`
                        }
                    });
                    return setSelectViewOption(value[0]);
                }}
                selectedItems={[selectViewOption]}
                inlineLabel
                size='sm'
            >
                {GLOBAL_RULE_TABLE_ORDER.map((option) => (
                    <option key={option.value} value={option.value}>
                        {t(option.label)}
                    </option>
                ))}
            </Select>
        </div>
    );
};
